import React from 'react'
import { Button as AntButton } from 'antd'
import { ButtonProps as AntButtonProps } from 'antd/lib/button'
import clsx from 'clsx'

import s from './Button.module.css'

type Props = AntButtonProps & {
  ref?: any
  type?: AntButtonProps['type'] | 'tonal'
  iconPlacement?: 'left' | 'right'
}

export class Button extends React.Component<Props> {
  render() {
    const {
      id,
      children,
      className,
      block,
      danger,
      disabled,
      ghost,
      htmlType,
      icon,
      loading,
      onClick,
      size,
      type,
      href,
      target,
      ref,
      shape,
      iconPlacement = 'left',
      // TODO: rest operator should be replaced with individual props
      ...rest
    } = this.props

    return (
      <AntButton
        ref={ref}
        id={id}
        className={clsx(className, s.btn, {
          [s.placeIconRight]: iconPlacement === 'right'
        })}
        block={block}
        danger={danger}
        disabled={disabled}
        ghost={ghost}
        htmlType={htmlType}
        icon={icon}
        loading={loading}
        onClick={onClick}
        size={size}
        type={type}
        href={href}
        target={target}
        shape={shape}
        {...rest}
      >
        {children}
      </AntButton>
    )
  }
}
